<template>
    <div>
        <slot :state="state" :open="open" :close="close" :data="data" :openWithData="openWithData" />
    </div>
</template>

<script>
export default {
    name: 'ModalControlComponent',

    props: {
        isOpen: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    data: () => ({
        state: false,
        data: null
    }),

    mounted: function() {
        this.state = this.isOpen ? true : false;
    },

    methods: {
        open: function() {
            this.state = true;
        },
        close: function() {
            this.state = false;
        },
        openWithData: function(data) {
            this.state = true;
            this.data = data;
        }
    }

}
</script>



// WEBPACK FOOTER //
// ModalControl.vue?1b942e96